import './styles.scss';
import { useEnv } from '../../../context/EnvironmentContext/EnvironmentContext';
import { Enviroment } from '@partnerconnect-monorepo/types/EnvironmentVariables';

export const EnvironmentBanner = () => {
  const env = useEnv();

  if (env?.environment && env.environment !== Enviroment.PROD) {
    return (
      <div
        className={`environment-indicator ${env.environment}`}
        role="presentation"
      >
        {env.environment}
      </div>
    );
  }
  return null;
};
